import {PaymentPolicyType, Experience} from '@wix/ambassador-table-reservations-v1-experience/types'
import {useCurrencyFormatter} from '@wix/yoshi-flow-editor'

import {DEFAULT_CURRENCY} from './constants'

export const useExperiencePaymentDetails = (experience?: Experience, partySize?: number | null) => {
  const formatCurrency = useCurrencyFormatter()

  if (!experience || !partySize) {
    return {
      isPaymentRuleActive: false,
      isPerGuestPayment: false,
      pricePerUnitWithCurrency: '',
      totalPriceWithCurrency: '',
    }
  }

  const paymentPolicy = experience?.configuration?.paymentPolicy!
  const currency = experience?.currency || DEFAULT_CURRENCY

  const isExperienceFree = paymentPolicy?.paymentPolicyType === PaymentPolicyType.FREE
  const isPaymentRuleActive = !isExperienceFree

  const pricePerUnit = isExperienceFree ? 0 : Number(paymentPolicy?.perGuestOptions?.price)
  const pricePerUnitWithCurrency = formatCurrency({value: pricePerUnit, currency})
  const totalPriceWithCurrency = formatCurrency({value: pricePerUnit * partySize, currency})

  return {
    isPaymentRuleActive,
    isPerGuestPayment: isPaymentRuleActive,
    pricePerUnitWithCurrency,
    totalPriceWithCurrency,
  }
}
